import { computed } from 'vue';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import { useProduct } from '~/modules/product/composables/useProduct';

function isMemberProduct(product?: Product) {
  if (!product) {
    return false;
  }

  const { isMemberProduct: flag } = useProductFlags();
  return flag;
}

export default function useMemberProduct() {
  const product = useProduct().productData as Product; // Will never be MemberProductMapProduct so we cast it temporarily
  if (isMemberProduct(product)) {
    const masterProductUrl = computed(() => product?.relationships?.masterProduct?.identifier?.productUrl);
    const orderedSiblingProductIds = computed(() => product?.relationships?.orderedSiblingProductIds?.length);

    return {
      masterProductUrl,
      orderedSiblingProductIds,
    };
  }
  return {
    masterProductUrl: computed(() => ''),
    orderedSiblingProductIds: computed(() => 0),
  };
}
